import React from 'react'

export const Footer = () => {

  return (

    <footer style={{width:'100%', height:'400px', backgroundColor:'greenyellow'}}>

    </footer>

  )
}
